module.exports = "<div class=\"content\" [style.height.px]=\"height\"><app-spinner-icon></app-spinner-icon></div>\n"